import { NavLink, useLocation } from "react-router-dom";
import { useCart } from "../../../app/context/cart-context/cart-context";
import { useEffect, useState } from "react";

import './footer.css'


export const Footer = () => {
    const { cart } = useCart();

    const  location = useLocation();

    const [counter, setCounter] = useState(0);

    useEffect(() => {
        const cartCount = cart.length;
        if (cartCount !== 0) {
            setCounter(cartCount)
        } else {
            setCounter(0)
        }
        
    }, [cart]);
    
    const isMenu = location.pathname.includes('/category/') || location.pathname.includes('/product/')  || location.pathname.includes('/search');

    const isCart = location.pathname.includes('/shipping') || location.pathname.includes('/checkout');
    
    return (
        <footer>
            <ul className="nav justify-content-center">
                <li className="nav-item">
                    <NavLink 
                        to='/' 
                        className={`nav-link сustom ${isMenu ? 'active' : ''}`}
                        >
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" id="restaurant">
                            <path fill="none" d="M0 0h24v24H0V0z"></path><path d="M8.1 13.34l2.83-2.83-6.19-6.18c-.48-.48-1.31-.35-1.61.27-.71 1.49-.45 3.32.78 4.56l4.19 4.18zm6.78-1.81c1.53.71 3.68.21 5.27-1.38 1.91-1.91 2.28-4.65.81-6.12-1.46-1.46-4.2-1.1-6.12.81-1.59 1.59-2.09 3.74-1.38 5.27L4.4 19.17c-.39.39-.39 1.02 0 1.41.39.39 1.02.39 1.41 0L12 14.41l6.18 6.18c.39.39 1.02.39 1.41 0 .39-.39.39-1.02 0-1.41L13.41 13l1.47-1.47z"></path>
                        </svg>
                        <span>Меню</span>
                    </NavLink>
                </li>
                <li className="nav-item">
                    <NavLink to='/cart' className={`nav-link сustom ${isCart ? 'active' : ''}`}>
                        {counter !== 0 &&
                            <div className="cart-counter">{counter}</div>
                        }
                        <svg xmlns="http://www.w3.org/2000/svg"  width="20" height="20" viewBox="0 0 512.002 512.002" id="cart">
                            <path d="M194.59 382.711c-35.646 0-64.646 29-64.646 64.646s29 64.646 64.646 64.646 64.646-29 64.646-64.646-29.001-64.646-64.646-64.646zm0 90.504c-14.261 0-25.858-11.597-25.858-25.858 0-14.261 11.597-25.858 25.858-25.858 14.254 0 25.858 11.597 25.858 25.858 0 14.26-11.597 25.858-25.858 25.858zm191.351-90.504c-35.646 0-64.646 29-64.646 64.646s29 64.646 64.646 64.646 64.646-29 64.646-64.646-29-64.646-64.646-64.646zm0 90.504c-14.261 0-25.858-11.597-25.858-25.858 0-14.261 11.597-25.858 25.858-25.858 14.261 0 25.858 11.597 25.858 25.858 0 14.26-11.597 25.858-25.858 25.858zm112.147-346.941a19.4 19.4 0 0 0-15.179-7.324H143.326l-17.629-89.095a19.392 19.392 0 0 0-15.528-15.308L32.594.325C22.038-1.621 11.953 5.368 10.02 15.905s5.042 20.641 15.58 22.574l64.607 11.843 56.914 287.667c1.797 9.083 9.768 15.631 19.025 15.631h271.512c9.031 0 16.86-6.225 18.896-15.037l45.252-195.876a19.38 19.38 0 0 0-3.718-16.433zm-75.855 188.559H182.074l-31.075-157.089h307.519l-36.285 157.089z"></path>
                        </svg>
                        <span>Кошик</span>
                    </NavLink>
                </li>
                <li className="nav-item">
                    <NavLink to='/history' className={`nav-link сustom ${isCart ? 'active' : ''}`}>
                        <svg xmlns="http://www.w3.org/2000/svg" data-name="Layer 2"  width="20" height="20" viewBox="0 0 24 24" id="list">
                            <path d="M18 15.33h-7.5c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h7.5c.41 0 .75.34.75.75s-.34.75-.75.75zM18 10.13h-7.5c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h7.5c.41 0 .75.34.75.75s-.34.75-.75.75zM6.89 10.96c-.19 0-.37-.07-.51-.2l-.89-.83c-.3-.28-.32-.76-.03-1.06.28-.3.76-.32 1.06-.03l.34.31 1-1.08c.28-.3.76-.32 1.06-.04.3.28.32.76.04 1.06l-1.51 1.63c-.14.15-.32.23-.52.24h-.03zM6.89 16.17c-.19 0-.37-.07-.51-.2l-.89-.83c-.3-.28-.32-.76-.03-1.06.28-.3.76-.32 1.06-.03l.34.31 1-1.08c.28-.3.76-.32 1.06-.04.3.28.32.76.04 1.06l-1.51 1.63c-.14.15-.32.23-.52.24h-.03z"></path><path d="M19,3.5c.83,0,1.5,.67,1.5,1.5v14c0,.83-.67,1.5-1.5,1.5H5c-.83,0-1.5-.67-1.5-1.5V5c0-.83,.67-1.5,1.5-1.5h14m0-1.5H5c-1.66,0-3,1.34-3,3v14c0,1.66,1.34,3,3,3h14c1.66,0,3-1.34,3-3V5c0-1.66-1.34-3-3-3h0Z"></path>
                        </svg>
                        <span>Замовлення</span>
                    </NavLink>
                </li>
                {/* <li className="nav-item">
                    <NavLink to='/setting' className={`nav-link`}>Налаштування</NavLink>
                </li> */}
            </ul>
        </footer>
    )
}